import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PipesModule} from '../../pipes/pipes.module';
import {AvatarPlaceholderComponent} from "./avatar-placeholder.component";



@NgModule({
    declarations: [AvatarPlaceholderComponent],
    exports: [
        AvatarPlaceholderComponent
    ],
    imports: [
        CommonModule,
        PipesModule
    ]
})
export class AvatarPlaceholderModule { }
